// extracted by mini-css-extract-plugin
export default {"progress__wrapper":"styles_progress__wrapper__iTaV4","progress__bar":"styles_progress__bar__1REtE"};